export type SubscriptionData = {
  id: string;
  "subscription-name": string;
  "offer-id": string;
  "plan-id": string;
  quantity: number;
  subscription: {
    "is-free-trial": boolean;
    "session-mode": string;
    "publisher-id": string;
    beneficiary: {
      "email-id": string;
      "object-id": string;
      "tenant-id": string;
      puid: string;
    };
    "is-test": boolean;
    name: string;
    "plan-id": string;
    "saas-subscription-status": string;
    "auto-renew": boolean;
    created: string;
    "last-modified": string;
    "sandbox-type": string;
    term: {
      "term-unit": string;
      "start-date"?: string;
      "end-date"?: string;
    };
    "offer-id": string;
    id: string;
    "allowed-customer-operations": Array<string>;
    quantity: number;
    purchaser: {
      "email-id": string;
      "object-id": string;
      "tenant-id": string;
      puid: string;
    };
  };
};

export const SubscriptionStatus = {
  REQUEST_CREATED: "REQUEST_CREATED",
  NOT_STARTED: "NOT_STARTED",
  STARTED: "STARTED",
  SUSPENDED: "SUSPENDED",
  CANCELLED: "CANCELLED",
} as const;

export type SubscriptionStatusType =
  (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];

export type SubscriptionMappingResponse = {
  "subscription-status":
    | "REQUEST_CREATED"
    | "NOT_STARTED"
    | "STARTED"
    | "SUSPENDED"
    | "CANCELLED";
};
